import { Box, CircularProgress, Divider } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";
import { useEffect } from "react";

import { OrganizationConfiguration } from "./components/OrganizationConfiguration";
import { Action } from "./components/Action";
import useEditOrganization from "./hooks/useEditOrganization";
import newOrganizationResolver from "../../../../libs/form-validations/organization";
import Breadcrumb from "./components/Breadcrumb";

import { Alert } from "../../../../shared";
import { useAuthorization } from "../../../../hooks";
import { ROLES } from "../../../../constants/permissions";

const INITIAL_VALUES = {
    Name: "",
    ShortName: "",
    Description: "",
    Website: "",
    LogoUrl: "",
    LogoFile: null,
    IsActive: true,
};

export default function Edit() {
    const { hasRole } = useAuthorization();
    const isSuperAdmin = hasRole(ROLES.SUPER_ADMIN);
    const { handleEditOrganization, editOrganizationSvc, organizationData, isLoading } = useEditOrganization();

    const methods = useForm({
        resolver: newOrganizationResolver,
        defaultValues: INITIAL_VALUES,
    });

    useEffect(() => {
        if (organizationData) {
            methods.reset({
                Name: organizationData.Name,
                ShortName: organizationData.ShortName || "",
                Description: organizationData.Description || "",
                Website: organizationData.Website || "",
                LogoUrl: organizationData.LogoUrl || "",
                LogoFile: null,
                IsActive: organizationData.IsActive === true || organizationData.IsActive === 1,
            });
        }
    }, [organizationData, methods]);

    if (!isSuperAdmin) {
        return (
            <Box flex={1} p={3}>
                <Alert errorMessage="Only Super Admin can edit organizations." />
            </Box>
        );
    }

    const onSubmit = methods.handleSubmit(handleEditOrganization);
    const isActive = organizationData?.IsActive === true || organizationData?.IsActive === 1;

    if (isLoading) {
        return (
            <Box flex={1} display="flex" justifyContent="center" alignItems="center">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box flex={1}>
            <Breadcrumb organizationName={organizationData?.Name} />

            <Divider />

            <Box component={"div"} ml={3} mt={2} width={700}>
                <FormProvider {...methods}>
                    <form onSubmit={onSubmit}>
                        <Box display={"flex"} gap={2} flexDirection={"column"}>
                            <OrganizationConfiguration
                                organizationId={organizationData?.Id}
                                isActive={isActive}
                            />
                            <Action api={editOrganizationSvc} />
                            <Alert
                                successMessage={editOrganizationSvc.isSuccess && "Organization updated successfully!"}
                                sx={{ mt: 3 }}
                                errorMessage={
                                    editOrganizationSvc.isError && "Failed to update organization. Please try again."
                                }
                            />
                        </Box>
                    </form>
                </FormProvider>
            </Box>
        </Box>
    );
}
